const port = 4000;

export const mainRoute = {
    local:`http://localhost:${port}/apiDelfos/`,
    public:`https://delfos369.com/apiDelfos/`
};